import {
  BlockBetween,
  BlockDes,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
} from "../Block/Block";

const PageHeader = ({ title, description }) => {
  return (
    <BlockHead className="mt-4" size="lg">
      <BlockBetween>
        <BlockHeadContent>
          <BlockTitle tag="h4" page>
            {title}
          </BlockTitle>
          <BlockDes className="text-soft">
            <p>
              {description ??
                `برای مدیریت ${title} بر روی هر سطر کلیک نمایید تا قابلیت های مربوطه را مشاهده نمایید`}
            </p>
          </BlockDes>
        </BlockHeadContent>
      </BlockBetween>
    </BlockHead>
  );
};

export default PageHeader;
